<script>
export default {
    name: "ProductMixin",
    computed: {
        showProductDescription () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_BRAND");
        },
        showProductBrand () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_DESCRIPTION");
        },
        showProductModel () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_MODEL");
        },
        showProductType () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_TYPE");
        },
        showProductAttributes () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_ATTRIBUTES");
        },
        showProductInStock () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_IN_STOCK");
        },
        showBuyPrice () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_BUY_PRICE");
        },
        showBuyPriceVat () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_BUY_PRICE_VAT");
        },
        showSellPrice () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_SELL_PRICE");
        },
        showSellPriceVat () {
            return this.showProductAttribute("VUE_APP_SHOW_PRODUCT_SELL_PRICE_VAT");
        }
    },
    methods: {
        showProductAttribute (attribute) {
            const value = process.env[attribute];
            return Number(value) === 1;
        }
    }
}
</script>
